import { Box, Flex, Grid, Heading, SystemStyleObject, Text } from '@chakra-ui/react';
import { AppLinkWithArrow, AppSpinner, pxToRem } from '@cyberkongz/ui';

type KollectionStatProps = {
  number?: number;
  label: string;
  link?: { label: string; href: string };
};

export function KollectionStat({ number, label, link }: KollectionStatProps) {
  return (
    <Grid gap={[2, 3]} css={{ color: 'textSecondary' }}>
      <Heading css={{ color: 'neutral.100' }}>{number || <AppSpinner />}</Heading>
      <Grid gap={2}>
        <Text css={{ textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: ['xs', 'md'] }}>
          {label}
        </Text>
        {link ? (
          <AppLinkWithArrow css={{ textTransform: 'uppercase', color: 'text' }} href={link.href}>
            {link.label}
          </AppLinkWithArrow>
        ) : null}
      </Grid>
    </Grid>
  );
}

export function KollectionStats({
  stylesContainer,
  stats,
}: {
  stylesContainer?: SystemStyleObject;
  stats: KollectionStatProps[];
}) {
  return (
    <Flex
      css={{
        flexWrap: 'wrap',
        rowGap: [5, 6],
        ...stylesContainer,
      }}
    >
      {stats.map((stat) => (
        <Box
          key={stat.label}
          css={{
            minWidth: pxToRem(135),
            w: ['50%', `calc(100% / ${stats.length})`],
            '&:not(:first-of-type)': {
              pl: '10%',
              borderLeft: 'thin',
            },
            '&:nth-of-type(2n +1)': {
              pl: [0, '10%'],
              borderLeft: ['none', 'thin'],
            },
            '&:first-of-type': {
              pl: 0,
              borderLeft: 'none',
            },
          }}
        >
          <KollectionStat {...stat} />
        </Box>
      ))}
    </Flex>
  );
}
